import { render, staticRenderFns } from "./mainAdminAreaChartVWE.vue?vue&type=template&id=bd486ba2&scoped=true"
import script from "./mainAdminAreaChartVWE.vue?vue&type=script&lang=js"
export * from "./mainAdminAreaChartVWE.vue?vue&type=script&lang=js"
import style0 from "./mainAdminAreaChartVWE.vue?vue&type=style&index=0&id=bd486ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd486ba2",
  null
  
)

export default component.exports